import { CURRENT_ENV, CURRENT_ENV_NAMES } from './types';

export function getConfigs(currentEnv: CURRENT_ENV) {
  let domain = '';

  if (currentEnv === CURRENT_ENV_NAMES.PROD) {
    domain = 'https://www.intermiles.com';
  } else {
    domain = 'https://uat.intermiles.com';
  }
  return { domain };
}

export function getOIDCEndPoints(oidcURL: string): Promise<any> {
  return new Promise(resolve => {
    fetch(oidcURL, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(_err => {
        console.log('IMAuthSDK get OIDC end points call Failed :: ', _err);
        resolve(_err);
      });
  });
}

export function isObjectEmpty(value: any): boolean {
  return value && Object.keys(value).length === 0 && Object.getPrototypeOf(value) === Object.prototype;
}

function generateRandomData(len) {
  // use web crypto APIs if possible
  let array: any = null;
  const crypto = window.crypto;
  if (crypto && crypto.getRandomValues && window.Uint8Array) {
    array = new Uint8Array(len);
    crypto.getRandomValues(array);
    return array;
  }

  // fallback to Math random
  array = new Array(len);
  for (let j = 0; j < array.length; j++) {
    array[j] = Math.floor(256 * Math.random());
  }
  return array;
}

function generateRandomString(len, alphabet) {
  const randomData = generateRandomData(len);
  const chars = new Array(len);
  for (let i = 0; i < len; i++) {
    chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
  }
  return String.fromCharCode.apply(null, chars);
}

export function createUUID() {
  const hexDigits = '0123456789abcdef';
  const s = generateRandomString(36, hexDigits).split('');
  s[14] = '4';
  s[19] = hexDigits.substring((s[19] as string & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  return s.join('');
}

export function getQueryString(queryParams) {
  return Object.keys(queryParams)
    .map(key => key + '=' + queryParams[key])
    .join('&');
}
